import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
  UploadPage
} from 'src/views/nbci/usproductmaster'
import pathMap from 'src/paths/pathMap'

class UsProductMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.US_PRODUCT_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.US_PRODUCT_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.US_PRODUCT_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.US_PRODUCT_MASTER_DETAILS_VIEW,
        component: ViewPage
      },
      {
        exact: true,
        path: pathMap.NBCI_UPLOAD,
        component: UploadPage
      }
    ]
  }
}

export default UsProductMasterRoute
